// extracted by mini-css-extract-plugin
export default {"footerContainer":"FooterComp_footerContainer__2y7mP"};